// Sperre fürs „Verlassen“ jenseits der Router-Navigation: Account wechseln oder
// anlegen stellt die Sitzung SERVERSEITIG um und lädt dann die Seite neu. Der
// Browser-Dialog aus beforeunload käme erst beim Neuladen — da ist die Sitzung
// schon umgestellt, und „Abbrechen“ hilft den laufenden Uploads nicht mehr.
// Deshalb fragt der Auslöser hier VORHER nach; die Tour-Seite hängt sich ein,
// solange Uploads laufen, und zeigt denselben Dialog wie bei In-App-Navigation.

/** Liefert true, wenn verlassen werden darf (Uploads sind dann bereits abgebrochen). */
type Guard = () => Promise<boolean>;

let guard: Guard | null = null;

export function registerLeaveGuard(g: Guard | null): void {
  guard = g;
}

export function confirmLeave(): Promise<boolean> {
  return guard ? guard() : Promise.resolve(true);
}
